import React from "react";
import { connect } from "react-redux";

import AddNewField from "./AddNewField";
import SourceField from "./SourceField";

import { SOURCE_FIELD } from "../../../../constants/fields";

const SrcFieldMapperBlock = ({
  draggedType,
  draggedFieldID,
  // sourceFields,
  sourceObjSchema,
  addFieldAllowed,
  currentSelectedObject,
  addNewField,
  removeField,
  revvField,
  // fieldMapping,
  objectFieldsMapping,
  searchInput,
  filterState,
  showMenuType,
  dataSourceSelected,
  csvData,
  emptyMappings,
}) => {
  const _addNewSourceField = (fieldName, fieldMapping) => {
    addNewField(fieldName, revvField, fieldMapping);
  };

  const _onDragOver = event => {
    event.preventDefault();
  };

  const _dropSourceField = (event, bool, fieldMapping) => {
    console.debug(bool);
    event.preventDefault();
    if (addFieldAllowed && draggedType === SOURCE_FIELD) {
      _addNewSourceField(draggedFieldID, fieldMapping);
    }
  };

  const _checkEmptyMapping = () => {
    if (emptyMappings.includes(revvField.id)) {
      return true;
    }
    return false;
  };
  filterState = "All";
  let fieldList =
    Object.keys(sourceObjSchema).length > 0 &&
    sourceObjSchema[currentSelectedObject]
      ? sourceObjSchema[currentSelectedObject][filterState]
      : [];
  if (
    dataSourceSelected === "csv" &&
    csvData &&
    Array.isArray(csvData.fields)
  ) {
    fieldList = csvData.fields;
  } else {
    if (searchInput && searchInput !== "") {
      fieldList = fieldList.filter(field =>
        field.label.toLowerCase().includes(searchInput.toLowerCase()),
      );
    }
    if (showMenuType === "TABLE") {
      fieldList =
        fieldList !== undefined &&
        Array.isArray(fieldList) &&
        fieldList.length > 0 &&
        fieldList.filter(
          field =>
            field.parent_field_type &&
            field.parent_field_type === "multi_reference",
        );
    } else {
      fieldList =
        Array.isArray(fieldList) &&
        fieldList.filter(
          field =>
            field.parent_field_type &&
            field.parent_field_type !== "multi_reference",
        );
    }
  }
  const options = Array.isArray(fieldList)
    ? fieldList.map(field => ({
        ...field,
        value: field.name,
      }))
    : [];

  if (!fieldList || !Array.isArray(fieldList)) return null;
  const objMapping = objectFieldsMapping.filter(obj => {
    if (obj.revvFieldID === revvField.id) {
      if (obj.revvSubField === null) {
        return obj;
      }
      if (obj.revvSubField === revvField.sub_field) {
        return obj;
      }
      return false;
    }
    return false;
  });

  if (objMapping.length > 0) {
    const sourceFieldsWithDefs = [];
    const {
      mapping: { source_fields: sourceFields },
    } = objMapping[0];
    if (
      dataSourceSelected === "csv"
      // csvData &&
      // Array.isArray(csvData.fields)
    ) {
      if (csvData && Array.isArray(csvData.fields)) {
        sourceFields.forEach(field => {
          const fieldDefs = csvData.fields.find(f => f.name === field.name);
          if (fieldDefs) {
            sourceFieldsWithDefs.push(fieldDefs);
          }
        });
      }
    } else {
      sourceFields.forEach(field => {
        const fieldDefs = sourceObjSchema[currentSelectedObject].All.find(
          f => f.name === field.name,
        );
        if (fieldDefs) {
          sourceFieldsWithDefs.push(fieldDefs);
        }
      });
    }

    return (
      <div
        onDrop={event => _dropSourceField(event, true, objMapping[0])}
        onDragOver={_onDragOver}
        className={`assigned-sf-fields ${
          _checkEmptyMapping() ? "emptymapping-error" : ""
        }`}>
        {/* for independent fields */}
        {Array.isArray(sourceFieldsWithDefs) &&
          objMapping &&
          objMapping.length > 0 &&
          objMapping[0].revvFieldID === revvField.id &&
          objMapping[0].revvSubField === null &&
          sourceFieldsWithDefs.map(obj => (
            <SourceField
              key={obj.name}
              id={obj.name}
              title={obj.label}
              removeField={removeField}
              fieldMapping={objMapping[0]}
              isRemoveAllowed
            />
          ))}
        {/* mapping for sub fields */}
        {Array.isArray(sourceFieldsWithDefs) &&
          objMapping &&
          objMapping.length > 0 &&
          objMapping[0].revvFieldID === revvField.id &&
          objMapping[0].revvSubField !== null &&
          objMapping[0].revvSubField === revvField.sub_field &&
          sourceFieldsWithDefs.map(obj => (
            <SourceField
              key={obj.name}
              id={obj.name}
              title={obj.label}
              removeField={removeField}
              fieldMapping={objMapping[0]}
              isRemoveAllowed
              emptyMappings={emptyMappings}
            />
          ))}
        {addFieldAllowed && (
          <AddNewField
            handleAddNewField={_addNewSourceField}
            fieldList={options}
            fieldMapping={objMapping[0]}
          />
        )}
      </div>
    );
  }

  let dummyMapping = {};
  if (objMapping.length === 0) {
    dummyMapping = {
      mappingID: Math.random().toString(36).substring(2, 7),
    };
  }

  return (
    <div
      onDrop={event => _dropSourceField(event, true, dummyMapping)}
      onDragOver={_onDragOver}
      className="assigned-sf-fields">
      {/* {Array.isArray(sourceFieldsWithDefs) &&
        fieldMapping &&
        fieldMapping.revvFieldID === revvField.id &&
        sourceFieldsWithDefs.map(obj => (
          <SourceField
            id={obj.name}
            title={obj.label}
            removeField={removeField}
            isRemoveAllowed
          />
        ))} */}
      {addFieldAllowed && (
        <AddNewField
          handleAddNewField={_addNewSourceField}
          fieldList={options}
          fieldMapping={dummyMapping}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({
  FieldsSettingStore: {
    draggedType,
    draggedFieldID,
    sourceObjSchema,
    currentSelectedObject,
    objectFieldsMapping,
    dataSourceSelected,
    csvData,
    emptyMappings,
  },
}) => ({
  draggedType,
  draggedFieldID,
  sourceObjSchema,
  currentSelectedObject,
  objectFieldsMapping,
  dataSourceSelected,
  csvData,
  emptyMappings,
});

export default connect(mapStateToProps, null)(SrcFieldMapperBlock);
